//import $ from 'jquery';

const
  NAME                 = 'dynamicArrow',
  VERSION              = '1.0.0',
  JQUERY_NO_CONFLICT   = $.fn[NAME],
  IS_CHROME            = is.chrome(),
  IS_MOBILE            = is.mobile()
;

/**
 * This plugin show Down or Up arrow on select elements inside the element selected
 * Down arrow: When select element is close
 * Up arrow: When select element is open
 */
class DynamicArrow {
  constructor(element$) {
    this._element$ = element$;
    this._arrow$   = element$.find('.downArrow');
    this._select$  = element$.find('select');

    this._select$.on('mouseup touchend',     () => this.onMouseUp());
    this._select$.on('mousedown touchstart', () => this.onMouseDown());
    this._select$.on('change blur',          () => this.close());
  }

  onMouseDown() {
    var state = this._element$.data('state');

    if (state === 1 || state === 3 || state === undefined) {
      this._arrow$.removeClass('downArrow').addClass('upArrow');
      this._element$.data('state', 2);
    }
  }

  onMouseUp() {
    var state = this._element$.data('state');

    // NOTE: Chrome has a bug, only detect mouseup and click events once when open and close select
    if (state === 2) {
      if (IS_CHROME && !IS_MOBILE) { // NOTE: Reset de arrow on chrome navigator
        this._arrow$.removeClass('upArrow').addClass('downArrow');
        this._element$.data('state', 1);
      } else { // NOTE: Firefox detect mouseup and click events twice when open and close select
        this._element$.data('state', 3);
      }
    } else if(state === 3) { // NOTE: Reset de arrow on NO chrome navigators
      this._arrow$.removeClass('upArrow').addClass('downArrow');
      this._element$.data('state', 1);
    }
  }

  // NOTE: Reset de arrow
  close() {
    this._arrow$.removeClass('upArrow').addClass('downArrow');
    this._element$.data('state', 1);
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new DynamicArrow($(this));
    });
  }
}

$.fn[NAME]             = DynamicArrow._jQueryInterface;
$.fn[NAME].Constructor = DynamicArrow;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return DynamicArrow._jQueryInterface;
};

export default DynamicArrow;



// WEBPACK FOOTER //
// ./src/plugins/dynamic-arrow.js